import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { stockService } from "../service/CreateStockService";

const AvailableStock = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // 🔍 FILTER STATE
  const [filters, setFilters] = useState({
    model: "",
    colour: "",
    location: "",
    minPrice: "",
    maxPrice: "",
    search: "",
  });

  // 🔄 Handle input
  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // 🚀 Fetch data
  const fetchStock = async (customFilters = {}) => {
    try {
      setLoading(true);

      const res = await stockService.filterStock({
        ...filters,
        ...customFilters,
      });

      setData(res.data || []);
    } catch (err) {
      console.error(err);
      setError("Failed to load stock");
    } finally {
      setLoading(false);
    }
  };

  // 🔎 Search button click
  const handleSearch = () => {
    fetchStock();
  };

  // 🔄 Reset filter
  const handleReset = () => {
    setFilters({
      model: "",
      colour: "",
      location: "",
      minPrice: "",
      maxPrice: "",
      search: "",
    });
    fetchStock({});
  };

  useEffect(() => {
    fetchStock();
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Available Stock (Admin)
      </Typography>

      {/* 🔥 FILTER SECTION */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2}>
          
          <Grid item xs={12} md={2}>
            <TextField
              label="Model"
              name="model"
              fullWidth
              value={filters.model}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              label="Colour"
              name="colour"
              fullWidth
              value={filters.colour}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              label="Location"
              name="location"
              fullWidth
              value={filters.location}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              label="Min Price"
              name="minPrice"
              type="number"
              fullWidth
              value={filters.minPrice}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              label="Max Price"
              name="maxPrice"
              type="number"
              fullWidth
              value={filters.maxPrice}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              label="Search (Engine/Chasis)"
              name="search"
              fullWidth
              value={filters.search}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleSearch}
            >
              Search
            </Button>
          </Grid>

          <Grid item xs={12} md={6}>
            <Button
              variant="outlined"
              fullWidth
              onClick={handleReset}
            >
              Reset
            </Button>
          </Grid>

        </Grid>
      </Paper>

      {/* 🔄 Loading */}
      {loading && <CircularProgress />}

      {/* ❌ Error */}
      {error && <Alert severity="error">{error}</Alert>}

      {/* 📊 DATA */}
      {!loading &&
        data.map((locationData, index) => (
          <Accordion key={index} defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>
                📍 {locationData.location} — Total: {locationData.total}
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Model</TableCell>
                      <TableCell>Colour</TableCell>
                      <TableCell>Chasis</TableCell>
                      <TableCell>Engine</TableCell>
                      <TableCell>Purchase Price</TableCell>
                      <TableCell>Location</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {locationData.bikes.map((bike) => (
                      <TableRow key={bike._id}>
                        <TableCell>{bike.model}</TableCell>
                        <TableCell>{bike.colour}</TableCell>
                        <TableCell>{bike.chasis}</TableCell>
                        <TableCell>{bike.engine}</TableCell>
                        <TableCell>{bike.purchasePrice}</TableCell>
                        <TableCell>{bike.location}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </AccordionDetails>
          </Accordion>
        ))}
    </Box>
  );
};

export default AvailableStock;